"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryPage = queryPage;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 获取地区信息
function queryPage(query) {
  return (0, _requestPIM.default)({
    url: '/xyRegion/page',
    method: 'get',
    params: query
  });
}